function setAnnouncementBarHeight() {
  const bar = document.querySelector('.announcement-bar');
  if (!bar) return;

  requestAnimationFrame(() => {
    const height = bar.offsetHeight;
    document.documentElement.style.setProperty('--announcement-height', `${height}px`);
    console.log('announceHeight', height);
  });
}
 
// initial
setAnnouncementBarHeight();

// recalc on resize (debounced)
let resizeTimer;
window.addEventListener('resize', () => {
  clearTimeout(resizeTimer);
  resizeTimer = setTimeout(setAnnouncementBarHeight, 150);
});
 

// SHOPIFY CHAT HACK
function openShopifyInbox() {
  const host = document.querySelector('inbox-online-store-chat'); 
  const button = host?.shadowRoot?.querySelector('[data-spec="toggle-button"]');
  button?.click();
}
 
 
